import ApiService from 'api/ApiService';
import {DialogTypes} from 'common/names';
import {layoutActions} from 'features/layout/redux';
import i18n from 'i18n';
import {call, put, SagaReturnType, select} from 'redux-saga/effects';
import {asyncSagaConstructor, SagaError} from 'redux/common';
import {ITransactionResponse} from 'types/TransactionResponse';
import {scheduleContent} from './scheduleContent';
import {pushSuccessToast} from 'features/notifications/redux/actions';

import {handleWarnings} from './handleWarnings';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {transactionSynchronizationGetters} from 'redux/transactions/transactionSynchronizationGetters';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {ISynchronization} from 'types/diplomat/transaction/Synchronization';
import {castToSend} from 'common/yup/castToSend';
import {packId} from 'common/diplomatIdUtil';
import {getTransactionErrorMessages} from 'common/messageUtils';
import {ITransactionErrorResponse} from 'types/diplomat/ErrorResponse';

// function* openConfirmDialog() {
//    yield put(
//       layoutActions.openSubDialog({
//          id: DialogTypes.ConfirmationDialog.id,
//          title: i18n.t('Save Transaction Confirmation'),
//          content: i18n.t(`Save transaction?`),
//       })
//    );
//    const result: ICloseSubDialogAction<string> = yield take(layoutTypes.CLOSE_SUB_DIALOG);
//    return result?.payload?.result === DialogResult.OK;
// }

export function* updateTransactionSaga(act: {
   type: string;
   payload: {data: ITransaction | ISynchronization};
}) {
   try {
      const data = act.payload.data;
      let isOk = true;

      if (!data.schedule.allowDaisyChained) {
         // isOk = yield call(openConfirmDialog); removed WEBADMIN-367
      }

      if (!isOk) {
         return;
      }

      // const isFeatureSupported = (yield select(licenseSelectors.isFeatureSupported)) as ReturnType<
      //    typeof licenseSelectors.isFeatureSupported
      // >;

      // if (isFeatureSupported(DiplomatFeature.PARTNERS)) {
      //    const newSourcePartner = yield call(checkPartner, data.sourcePartner, true, data.type);
      //    if (newSourcePartner) {
      //       data.sourcePartner = newSourcePartner;
      //    }

      //    const newDestPartner = yield call(checkPartner, data.destinationPartner, false, data.type);
      //    if (newDestPartner) {
      //       data.destinationPartner = newDestPartner;
      //    }
      // }
      // else {
      //    yield call(makePartnersAnonymous, data);
      // }

      // if (!data.schedule.disabled ||
      //    data.schedule.allowScriptingAgent ||
      //    data.schedule.allowDaisyChained ||
      //    data.schedule.useFileSystemMonitor) {
      //    yield call(checkAeks, data);

      //    if (isFeatureSupported(DiplomatFeature.IT_EMAIL)) {
      //       yield call(checkItDebug, data);
      //    }

      //    yield call(checkForDaisyChainedRecursion, data);
      // }

      const isSynchronization = (yield select(pageSelectors.isSynchronization)) as boolean;
      let {api, reduxType, label, schema} = isSynchronization
         ? transactionSynchronizationGetters.Synchronization
         : transactionSynchronizationGetters.Transaction;

      const postSaga = (yield call(asyncSagaConstructor, api, reduxType, {
         getMethod: ApiService.postSecureJson,
         // data,
         data: castToSend(schema as any, data, {
            stripUnknown: true,
         }),
         hideErrorToast: true,
      })) as SagaReturnType<typeof asyncSagaConstructor>;
      const resp: ITransactionResponse = yield call(postSaga);

      yield put(
         pushSuccessToast(scheduleContent(data.name, resp.scheduledTimes, label))
         // layoutActions.openSubDialog({
         //    id: DialogTypes.AlertDialog.id,
         //    title: i18n.t('Transaction Save Status'),
         //    content: scheduleContent(data.name, resp.scheduledTimes),
         // })  // WEBADMIN-367
      );

      yield call(handleWarnings, resp.warnings);

      // console.debug('updateTransaction', resp);
      const getter = (yield select(
         pageSelectors.getDirtyValuesGetter(packId(data.objectType, data.id))
      )) as ReturnType<ReturnType<typeof pageSelectors.getDirtyValuesGetter>>;

      getter?.resetForm(resp.transaction);
   } catch (e) {
      console.error(e);

      const messages = getTransactionErrorMessages(
         (e as ITransactionErrorResponse).errorBody,
         (e as ITransactionErrorResponse).errorMessage || (e as SagaError).message
      );

      yield put(
         layoutActions.openSubDialog({
            id: DialogTypes.AlertDialog.id,
            title: i18n.t('Update Errors'),
            content: messages,
            maxWidth: 'md',
         })
      );
   }
}
